module.exports = __webpack_public_path__ + "img/_gadgets.c2b85fa2.jpg";